import React, { useCallback, useRef } from 'react';
import { useMapEvent } from 'react-leaflet';

const ConfigDebuggerComponent = React.memo(() => {
  const timer = useRef(null);

  const onClick = useCallback(({ latlng }) => {
    // eslint-disable-next-line
    console.log('/* --------------------------------------------------');
    // eslint-disable-next-line
    console.log('latlng', latlng);
    // eslint-disable-next-line
    console.log('-------------------------------------------------- */');
  }, []);

  const onMoveStart = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  }, []);

  const onMoveEnd = useCallback(({ target: map }) => {
    timer.current = setTimeout(() => {
      const zoom = map.getZoom();
      const center = map.getCenter();
      const bounds = map.getBounds();
      // eslint-disable-next-line
      console.log('/* --------------------------------------------------');
      // eslint-disable-next-line
      console.log('zoom', zoom);
      // eslint-disable-next-line
      console.log('center', center);
      // eslint-disable-next-line
      console.log('bounds', bounds);
      // eslint-disable-next-line
      console.log('-------------------------------------------------- */');
    }, 500);
  }, []);

  useMapEvent('click', onClick);
  useMapEvent('moveend', onMoveEnd);
  useMapEvent('movestart', onMoveStart);

  return null;
});

ConfigDebuggerComponent.displayName = 'ConfigDebuggerComponent';

export default ConfigDebuggerComponent;
